module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/alcada-alert/alcada-alert.component.scss
// module id = ./src/app/account-client/component/account-client-details/alcada-alert/alcada-alert.component.scss
// module chunks = main